// slightly unusual entrypoint as it's not react based (there are no interactions on this page)
// we've removed even some "common" dependencies that are unused by this entrypoint to keep the
// weight down
import "./css-track-redirect";

import { renderReact } from "@lyst/hypernova-react";
import "web/entrypoints/common/polyfills";
import { setupSentry } from "web/entrypoints/common/sentry_from_loader";
import { withReactStrictMode } from "web/react/hoc/with-react-strict-mode";
import analytics from "web/script/analytics/analytics";
import userProfiler from "web/script/modules/userprofiler";
import browser from "web/script/utils/browser";
import history from "web/script/utils/history";
import components from "./react-track-redirect";

// custom setup with fewer things than `entrypoints/common/setup`
// notably eg no react components, no jinja-to-js, and sentry from their script loader
function setup(): void {
    setupSentry();

    analytics.init();
    userProfiler.init();
    browser.init();
    history.start();
    analytics.pageView();

    for (let [name, component] of Object.entries(components)) {
        renderReact(name, withReactStrictMode(component));
    }

    // we expose this as a global so 3rd parties can interact with our analytics
    window["lystAnalytics"] = {
        event: analytics.event.bind(analytics),
    };
}
setup();
